import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { MoreVertical } from "lucide-react";

const MenuWrapper = styled.div`
  position: relative;
  display: inline-block;
  line-height: 0;
`;

const IconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: ${({ $compact }) => ($compact ? "1px" : "4px")};
  display: inline-grid;
  place-items: center;
  border-radius: 6px;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }

  svg {
    color: #999;
    width: ${({ $compact }) => ($compact ? "14px" : "18px")};
    height: ${({ $compact }) => ($compact ? "14px" : "18px")};
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: ${({ $dropUp }) => ($dropUp ? "auto" : "28px")};
  bottom: ${({ $dropUp }) => ($dropUp ? "24px" : "auto")};
  right: 0;
  background: #1e1e1e;
  border: 1px solid #333;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  z-index: 1000;
  min-width: 120px;
  padding: 6px 0;
`;

const MenuItem = styled.div`
  padding: 8px 12px;
  color: #e1e1e1;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;

  &:hover {
    background-color: #2c2c2c;
    color: #00eaff;
  }
`;

const DropdownMenu = ({ onEdit, onDelete, compact = false, dropUp = false }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const handleEdit = () => {
    setOpen(false);
    onEdit();
  };

  const handleDelete = () => {
    setOpen(false);
    onDelete();
  };

  return (
    <MenuWrapper ref={menuRef}>
      <IconButton
        type="button"
        $compact={compact}
        aria-label="Ações do servidor"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <MoreVertical />
      </IconButton>

      {open && (
        <Dropdown $dropUp={dropUp}>
          <MenuItem onClick={handleEdit}>Editar</MenuItem>
          <MenuItem onClick={handleDelete}>Excluir</MenuItem>
        </Dropdown>
      )}
    </MenuWrapper>
  );
};

export default DropdownMenu;
